import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '../index'

const RewardsEdit = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Mask
      id="a"
      width={24}
      height={25}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M0 .5h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#6826A0"
        d="M2 24.5v-4h20v4H2Zm2-6v-3.75l9.05-9.05 3.75 3.75-9.05 9.05H4Zm2-2h.9L14 9.45l-.95-.95L6 15.6v.9Zm11.925-8.15-3.75-3.75 1.8-1.8a.87.87 0 0 1 .7-.288.992.992 0 0 1 .7.288l2.35 2.35a.933.933 0 0 1 .275.687c0 .275-.092.513-.275.713l-1.8 1.8Z"
      />
    </G>
  </Svg>
)
export default RewardsEdit
